import "./App.css";



import AppRoutes from "./routes/AppRoutes";

import ScrollToTop from "./hooks/ScrollToTop";

function App() {

    return (

        <>

            {/* <ScrollToTop /> */}

            {/* <Navbar /> */}

            <AppRoutes />

            {/* <Footer /> */}

        </>

    );

}

export default App;